export default __webpack_public_path__ + "static/media/38_mobile.6190b7fe.jpeg";